import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/src/app/sections/challenges/page.jsx");
